<div class="d-flex justify-content-between align-items-center w-100 flex-nowrap bg-white nav-header-backgroud border-bottom">
  <!-- Logo and Text -->
  <div class="d-flex align-items-center gap-3 px-2 h-100">
    <img src="../../../../../assets/img/toyota-logo-red.png" class="img-alg cu" alt="HCM TMMA Logo">
    <div class="hcm-title-navbar cu h-100 d-flex align-items-center" (click)="goToHome()" aria-current="page">HCM-{{namcName}}</div>
    <a routerLink="/home" class="d-md-flex d-none align-items-center h-100 px-3 ms-3" routerLinkActive="active-menu"
      [routerLinkActiveOptions]="{ exact: true }" (click)="goToHome()" [class.hcm-disabled]="isIconsDisabled()">
      <img src="../../../../../assets/img/disabled-home.svg" alt="Home Icon" class="img-alg-home cu" />
    </a>
  </div>

  <div class="d-flex align-items-center gap-4 px-2 h-100">
    <div class="h-100 d-flex align-items-center">
      <img [ngClass]='{"d-none" : online}' src="../../../../../assets/img/globe-offline.svg" alt="Offline" class="img-lang" />
      <img [ngClass]='{"d-none" : !online}' src="../../../../../assets/img/globe-online.svg" alt="Online" class="img-lang" />
    </div>
    <div class="h-100 d-flex align-items-center" (click)="isIconsDisabled() ? null : gotoProfile('view-profile')" [class.hcm-disabled]="isIconsDisabled()">
      <img src="../../../../../assets/img/user-icon.svg" alt="Profile" class="img-alg cu" />
    </div>
    <div class="h-100 d-flex align-items-center" [class.hcm-disabled]="isIconsDisabled()">
      <img src="../../../../../assets/img/logout.svg" (click)="isIconsDisabled() ? null : logout()" alt="Power"
        class="img-alg cu"/>
    </div>
  </div>
</div>